export function CheckedIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.25 2.5H3.75C3.41848 2.5 3.10054 2.6317 2.86612 2.86612C2.6317 3.10054 2.5 3.41848 2.5 3.75V16.25C2.5 16.5815 2.6317 16.8995 2.86612 17.1339C3.10054 17.3683 3.41848 17.5 3.75 17.5H16.25C16.5815 17.5 16.8995 17.3683 17.1339 17.1339C17.3683 16.8995 17.5 16.5815 17.5 16.25V3.75C17.5 3.41848 17.3683 3.10054 17.1339 2.86612C16.8995 2.6317 16.5815 2.5 16.25 2.5ZM8.75 13.4375L5.625 10.3394L6.61875 9.375L8.75 11.4663L13.3806 6.875L14.375 7.86062L8.75 13.4375Z"
        fill="#7E00FD"
      />
    </svg>
  );
}
export function ArrowIcon() {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.5 2.25L8.25 6L4.5 9.75"
        stroke="#7E00FD"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function DueDateIcon() {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="13"
        cy="13"
        r="12"
        stroke="#292E73"
        strokeOpacity="0.42"
        strokeLinecap="round"
        strokeDasharray="3 4"
      />
      <path
        d="M17.375 8.1875H8.625C8.38338 8.1875 8.1875 8.38338 8.1875 8.625V17.375C8.1875 17.6166 8.38338 17.8125 8.625 17.8125H17.375C17.6166 17.8125 17.8125 17.6166 17.8125 17.375V8.625C17.8125 8.38338 17.6166 8.1875 17.375 8.1875Z"
        stroke="#7E00FD"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.625 7.3125V9.0625"
        stroke="#7E00FD"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.375 7.3125V9.0625"
        stroke="#7E00FD"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.1875 10.8125H17.8125"
        stroke="#7E00FD"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

interface ArrowDownIconProps {
  width: number;
  color: string;
}
export function ArrowDownIcon(props: ArrowDownIconProps) {
  return (
    <svg
      width={props.width + ""}
      height={props.width + ""}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.75 4.5L6 8.25L2.25 4.5"
        stroke={props.color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
ArrowDownIcon.defaultProps = {
  width: 12,
  color: "rgba(41, 46, 115, 0.82)",
};

export function BLockIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 13.5C11.0376 13.5 13.5 11.0376 13.5 8C13.5 4.96243 11.0376 2.5 8 2.5C4.96243 2.5 2.5 4.96243 2.5 8C2.5 11.0376 4.96243 13.5 8 13.5Z"
        stroke="#7E00FD"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 8.00026L10.4749 5.52539"
        stroke="#7E00FD"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.5 0.5H9.5"
        stroke="#7E00FD"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

interface PlusIconProps {
  width: number;
  color: string;
}
export function PlusIcon(props: PlusIconProps) {
  return (
    <svg
      width={props.width + ""}
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 8H14"
        stroke={props.color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.5 2.5V13.5"
        stroke={props.color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
PlusIcon.defaultProps = {
  width: 17,
  color: "#7E00FD",
};

export function FileIcon() {
  return (
    <svg
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.37537 11H2.625C2.52554 11 2.43016 10.9605 2.35983 10.8902C2.28951 10.8198 2.25 10.7245 2.25 10.625V2.375C2.25 2.27554 2.28951 2.18016 2.35983 2.10984C2.43016 2.03951 2.52554 2 2.625 2H7.12537L9.75037 4.625V10.625C9.75037 10.6742 9.74067 10.723 9.72182 10.7685C9.70298 10.814 9.67535 10.8553 9.64053 10.8902C9.60571 10.925 9.56437 10.9526 9.51887 10.9715C9.47338 10.9903 9.42461 11 9.37537 11Z"
        stroke="#292E73"
        strokeOpacity="0.42"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.125 2V4.625H9.75037"
        stroke="#292E73"
        strokeOpacity="0.42"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function LikeIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.5 8.125H6.25V16.25H2.5C2.33424 16.25 2.17527 16.1842 2.05806 16.0669C1.94085 15.9497 1.875 15.7908 1.875 15.625V8.75C1.875 8.58424 1.94085 8.42527 2.05806 8.30806C2.17527 8.19085 2.33424 8.125 2.5 8.125V8.125Z"
        stroke="#A5A7C4"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.25 8.125L9.375 1.875C9.7033 1.875 10.0284 1.93966 10.3317 2.0653C10.635 2.19094 10.9106 2.37509 11.1428 2.60723C11.3749 2.83938 11.5591 3.11498 11.6847 3.41829C11.8103 3.72161 11.875 4.0467 11.875 4.375V6.25H16.709C16.8863 6.25 17.0615 6.28769 17.223 6.36058C17.3846 6.43346 17.5288 6.53987 17.6461 6.67275C17.7634 6.80562 17.8511 6.96192 17.9034 7.13128C17.9557 7.30063 17.9714 7.47917 17.9494 7.65504L17.0119 15.155C16.9741 15.4574 16.8272 15.7355 16.5988 15.9371C16.3704 16.1387 16.0762 16.25 15.7715 16.25H6.25"
        stroke="#A5A7C4"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function PaperClipIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99963 5L4.79289 10.2932C4.60536 10.4807 4.5 10.7351 4.5 11.0003C4.5 11.2655 4.60536 11.5199 4.79289 11.7074C4.98043 11.8949 5.23478 12.0003 5.5 12.0003C5.76522 12.0003 6.01957 11.8949 6.20711 11.7074L12.4138 5.41421C12.5996 5.2285 12.7469 5.00802 12.8474 4.76537C12.9479 4.52272 12.9996 4.26264 12.9996 4C12.9996 3.73736 12.9479 3.47728 12.8474 3.23463C12.7469 2.99198 12.5996 2.7715 12.4138 2.58579C12.2281 2.40007 12.0077 2.25275 11.765 2.15224C11.5223 2.05173 11.2623 2 10.9996 2C10.737 2 10.4769 2.05173 10.2343 2.15224C9.99161 2.25275 9.77114 2.40007 9.58542 2.58579L3.37868 8.87898C2.81607 9.44159 2.5 10.2047 2.5 11.0003C2.5 11.796 2.81607 12.559 3.37868 13.1216C3.94129 13.6842 4.70435 14.0003 5.5 14.0003C6.29565 14.0003 7.05871 13.6842 7.62132 13.1216L12.7496 8"
        stroke="#7E00FD"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function CrosshairIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 13.5C11.0376 13.5 13.5 11.0376 13.5 8C13.5 4.96243 11.0376 2.5 8 2.5C4.96243 2.5 2.5 4.96243 2.5 8C2.5 11.0376 4.96243 13.5 8 13.5Z"
        stroke="#43D795"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 1.25V3.75"
        stroke="#43D795"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.25 8H3.75"
        stroke="#43D795"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 14.75V12.25"
        stroke="#43D795"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.75 8H12.25"
        stroke="#43D795"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z"
        stroke="#43D795"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function TrashIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.5 3.5L2.5 3.50001"
        stroke="#E94600"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.5 6.5V10.5"
        stroke="#E94600"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.5 6.5V10.5"
        stroke="#E94600"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 3.5V13C12.5 13.1326 12.4473 13.2598 12.3536 13.3536C12.2598 13.4473 12.1326 13.5 12 13.5H4C3.86739 13.5 3.74021 13.4473 3.64645 13.3536C3.55268 13.2598 3.5 13.1326 3.5 13V3.5"
        stroke="#E94600"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 3.5V2.5C10.5 2.23478 10.3946 1.98043 10.2071 1.79289C10.0196 1.60536 9.76522 1.5 9.5 1.5H6.5C6.23478 1.5 5.98043 1.60536 5.79289 1.79289C5.60536 1.98043 5.5 2.23478 5.5 2.5V3.5"
        stroke="#E94600"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function TextIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 3.42857C14 3.21429 13.7857 3 13.5714 3H2.42857C2.1875 3 2 3.21429 2 3.42857V5.35714C2 5.49107 2.08036 5.57143 2.21429 5.57143H2.64286C2.75 5.57143 2.85714 5.49107 2.85714 5.35714V3.85714H7.57143V14.1429H5.64286C5.50893 14.1429 5.42857 14.25 5.42857 14.3571V14.7857C5.42857 14.9196 5.50893 15 5.64286 15H10.3571C10.4643 15 10.5714 14.9196 10.5714 14.7857V14.3571C10.5714 14.25 10.4643 14.1429 10.3571 14.1429H8.42857V3.85714H13.1429V5.35714C13.1429 5.49107 13.2232 5.57143 13.3571 5.57143H13.7857C13.8929 5.57143 14 5.49107 14 5.35714V3.42857Z"
        fill="#292E73"
        fillOpacity="0.42"
      />
      <path
        d="M14.1 3.42857C14.1 3.28891 14.0312 3.15761 13.9368 3.06322C13.8424 2.96883 13.7111 2.9 13.5714 2.9H2.42857C2.1283 2.9 1.9 3.16311 1.9 3.42857V5.35714C1.9 5.44416 1.9265 5.52551 1.98621 5.58522C2.04592 5.64493 2.12727 5.67143 2.21429 5.67143H2.64286C2.79686 5.67143 2.95714 5.55431 2.95714 5.35714V3.95714H7.47143V14.0429H5.64286C5.44569 14.0429 5.32857 14.2031 5.32857 14.3571V14.7857C5.32857 14.8727 5.35507 14.9541 5.41478 15.0138C5.47449 15.0735 5.55584 15.1 5.64286 15.1H10.3571C10.5111 15.1 10.6714 14.9829 10.6714 14.7857V14.3571C10.6714 14.271 10.6294 14.1933 10.5752 14.1391C10.521 14.0849 10.4432 14.0429 10.3571 14.0429H8.52857V3.95714H13.0429V5.35714C13.0429 5.44416 13.0694 5.52551 13.1291 5.58522C13.1888 5.64493 13.2701 5.67143 13.3571 5.67143H13.7857C13.9397 5.67143 14.1 5.55431 14.1 5.35714V3.42857Z"
        stroke="#292E73"
        strokeOpacity="0.42"
        strokeWidth="0.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function SmileyIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z"
        stroke="#292E73"
        strokeOpacity="0.42"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5986 9.5C10.3351 9.95589 9.95619 10.3344 9.50006 10.5976C9.04394 10.8607 8.52661 10.9993 8.00001 10.9993C7.47342 10.9993 6.95608 10.8608 6.49995 10.5976C6.04382 10.3344 5.66495 9.95593 5.40137 9.50004"
        stroke="#292E73"
        strokeOpacity="0.42"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.75 7.5C6.16421 7.5 6.5 7.16421 6.5 6.75C6.5 6.33579 6.16421 6 5.75 6C5.33579 6 5 6.33579 5 6.75C5 7.16421 5.33579 7.5 5.75 7.5Z"
        fill="#292E73"
        fillOpacity="0.42"
      />
      <path
        d="M10.25 7.5C10.6642 7.5 11 7.16421 11 6.75C11 6.33579 10.6642 6 10.25 6C9.83579 6 9.5 6.33579 9.5 6.75C9.5 7.16421 9.83579 7.5 10.25 7.5Z"
        fill="#292E73"
        fillOpacity="0.42"
      />
    </svg>
  );
}
export function UrlLinkIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.87891 10.1215L10.1215 5.87891"
        stroke="#292E73"
        strokeOpacity="0.42"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.0606 11.1821L7.29283 12.9499C6.73019 13.5123 5.96718 13.8282 5.17162 13.8282C4.37606 13.8281 3.6131 13.512 3.05055 12.9495C2.48801 12.3869 2.17194 11.624 2.17188 10.8284C2.17181 10.0329 2.48774 9.26986 3.05019 8.70722L4.81796 6.93945"
        stroke="#292E73"
        strokeOpacity="0.42"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.1821 9.0606L12.9499 7.29283C13.5123 6.73019 13.8282 5.96718 13.8282 5.17162C13.8281 4.37606 13.512 3.6131 12.9495 3.05055C12.387 2.48801 11.624 2.17194 10.8284 2.17188C10.0329 2.17181 9.26986 2.48774 8.70722 3.05019L6.93945 4.81796"
        stroke="#292E73"
        strokeOpacity="0.42"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function GrayAttachIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99963 5L4.79289 10.2932C4.60536 10.4807 4.5 10.7351 4.5 11.0003C4.5 11.2655 4.60536 11.5199 4.79289 11.7074C4.98043 11.8949 5.23478 12.0003 5.5 12.0003C5.76522 12.0003 6.01957 11.8949 6.20711 11.7074L12.4138 5.41421C12.5996 5.2285 12.7469 5.00802 12.8474 4.76537C12.9479 4.52272 12.9996 4.26264 12.9996 4C12.9996 3.73736 12.9479 3.47728 12.8474 3.23463C12.7469 2.99198 12.5996 2.7715 12.4138 2.58579C12.2281 2.40007 12.0077 2.25275 11.765 2.15224C11.5223 2.05173 11.2623 2 10.9996 2C10.737 2 10.4769 2.05173 10.2343 2.15224C9.99161 2.25275 9.77114 2.40007 9.58542 2.58579L3.37868 8.87898C2.81607 9.44159 2.5 10.2047 2.5 11.0003C2.5 11.796 2.81607 12.559 3.37868 13.1216C3.94129 13.6842 4.70435 14.0003 5.5 14.0003C6.29565 14.0003 7.05871 13.6842 7.62132 13.1216L12.7496 8"
        stroke="#292E73"
        strokeOpacity="0.42"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function AtIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.6681 11.7384H15C14.6892 12.3742 14.154 12.9737 13.3943 13.5367C12.7283 14.0414 11.9982 14.4103 11.204 14.6433C10.4098 14.8811 9.49718 15 8.46617 15C7.31184 15 6.27097 14.8495 5.34355 14.5486C4.42107 14.2477 3.63672 13.8133 2.99049 13.2455C2.34426 12.6824 1.85095 11.9932 1.51057 11.1778C1.17019 10.3625 1 9.45484 1 8.45502C1 7.57653 1.13319 6.72716 1.39958 5.90692C1.67089 5.08182 2.05814 4.33437 2.56131 3.66459C3.06448 2.98995 3.64905 2.44878 4.31501 2.04108C4.66032 1.82267 5.05497 1.63581 5.49894 1.4805C5.94785 1.32033 6.41156 1.20142 6.89006 1.12376C7.36857 1.04125 7.84461 1 8.31818 1C9.52185 1 10.6071 1.2451 11.574 1.73531C12.5409 2.22066 13.2956 2.89773 13.8383 3.76651C14.3809 4.63529 14.6522 5.606 14.6522 6.67863C14.6522 7.55712 14.4401 8.3992 14.0159 9.20489C13.5965 10.0106 13.0416 10.6609 12.351 11.156C11.6603 11.6511 10.9426 11.8986 10.1977 11.8986C9.41332 11.8986 8.95948 11.6365 8.83615 11.1123C8.80162 10.9958 8.77942 10.8502 8.76956 10.6755C8.42918 11.0589 8.06166 11.3599 7.66702 11.5783C7.27238 11.7918 6.88266 11.8986 6.49789 11.8986C6.00458 11.8986 5.55321 11.7554 5.14376 11.4691C4.73432 11.1778 4.41121 10.7847 4.17442 10.2897C3.93763 9.78974 3.81924 9.23401 3.81924 8.62246C3.81924 7.85561 4.00176 7.11302 4.36681 6.3947C4.73679 5.67152 5.22023 5.0891 5.81712 4.64743C6.41402 4.20575 7.02572 3.98492 7.65222 3.98492C8.58457 3.98492 9.33192 4.43144 9.89429 5.32449L10.1385 4.18877H11.4704L10.3901 9.08112C10.3654 9.20246 10.3457 9.29468 10.3309 9.35777C10.321 9.41602 10.3062 9.49367 10.2865 9.59074C10.2174 9.8771 10.1829 10.0858 10.1829 10.2168C10.1829 10.3382 10.2347 10.4474 10.3383 10.5445C10.4419 10.6415 10.5603 10.6901 10.6934 10.6901C10.8562 10.6901 11.0733 10.6173 11.3446 10.4717C11.6209 10.3212 11.8798 10.1416 12.1216 9.93292C12.3534 9.71936 12.5557 9.48882 12.7283 9.24129C12.901 8.99376 13.044 8.73167 13.1575 8.45502C13.2759 8.17837 13.3696 7.88958 13.4387 7.58866C13.5078 7.28289 13.5423 6.96984 13.5423 6.64951C13.5423 5.79043 13.3129 5.00901 12.8541 4.30525C12.3953 3.60149 11.759 3.05062 10.945 2.65263C10.136 2.25464 9.23573 2.05564 8.24419 2.05564C7.37104 2.05564 6.55708 2.21096 5.80233 2.52158C5.0525 2.82735 4.39887 3.26417 3.84144 3.83203C3.284 4.3999 2.85236 5.06968 2.54651 5.84139C2.24066 6.6131 2.08774 7.44548 2.08774 8.33853C2.08774 9.50823 2.33932 10.5129 2.84249 11.3526C3.3506 12.1922 4.08316 12.8305 5.04017 13.2673C5.99718 13.709 7.14905 13.9298 8.49577 13.9298C9.27026 13.9298 9.96829 13.8497 10.5899 13.6895C11.2114 13.5294 11.8034 13.2746 12.3658 12.9251C12.7012 12.7164 12.9503 12.5393 13.1131 12.3937C13.2759 12.248 13.4609 12.0296 13.6681 11.7384ZM5.18076 8.70983C5.18076 9.10782 5.24982 9.46941 5.38795 9.79459C5.52607 10.1149 5.71353 10.3649 5.95032 10.5445C6.19204 10.724 6.46582 10.8138 6.77167 10.8138C7.10218 10.8138 7.42777 10.7143 7.74841 10.5153C8.074 10.3115 8.36751 10.0373 8.62896 9.69267C8.89042 9.34321 9.09514 8.95008 9.24313 8.51326C9.39605 8.07644 9.47252 7.62992 9.47252 7.17369C9.47252 6.74658 9.40099 6.37285 9.25793 6.05252C9.11487 5.73219 8.91261 5.48709 8.65116 5.31721C8.38971 5.14249 8.0814 5.05512 7.72622 5.05512C7.4105 5.05512 7.09725 5.15705 6.78647 5.36089C6.48062 5.55989 6.2093 5.82926 5.97252 6.16901C5.73573 6.50875 5.54334 6.90674 5.39535 7.36297C5.25229 7.81435 5.18076 8.2633 5.18076 8.70983Z"
        fill="#292E73"
        fillOpacity="0.42"
      />
    </svg>
  );
}

export function MenuIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99935 10.8327C10.4596 10.8327 10.8327 10.4596 10.8327 9.99935C10.8327 9.53911 10.4596 9.16602 9.99935 9.16602C9.53911 9.16602 9.16602 9.53911 9.16602 9.99935C9.16602 10.4596 9.53911 10.8327 9.99935 10.8327Z"
        stroke="#292E73"
        strokeOpacity="0.42"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99935 5.00065C10.4596 5.00065 10.8327 4.62756 10.8327 4.16732C10.8327 3.70708 10.4596 3.33398 9.99935 3.33398C9.53911 3.33398 9.16602 3.70708 9.16602 4.16732C9.16602 4.62756 9.53911 5.00065 9.99935 5.00065Z"
        stroke="#292E73"
        strokeOpacity="0.42"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99935 16.6667C10.4596 16.6667 10.8327 16.2936 10.8327 15.8333C10.8327 15.3731 10.4596 15 9.99935 15C9.53911 15 9.16602 15.3731 9.16602 15.8333C9.16602 16.2936 9.53911 16.6667 9.99935 16.6667Z"
        stroke="#292E73"
        strokeOpacity="0.42"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function EditIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 13.4999H3C2.86739 13.4999 2.74021 13.4472 2.64645 13.3535C2.55268 13.2597 2.5 13.1325 2.5 12.9999V10.207C2.5 10.1414 2.51293 10.0764 2.53806 10.0157C2.56319 9.95503 2.60002 9.89991 2.64645 9.85348L10.1464 2.35348C10.2402 2.25971 10.3674 2.20703 10.5 2.20703C10.6326 2.20703 10.7598 2.25971 10.8536 2.35348L13.6464 5.14637C13.7402 5.24014 13.7929 5.36732 13.7929 5.49992C13.7929 5.63253 13.7402 5.75971 13.6464 5.85348L6 13.4999Z"
        stroke="#F57F20"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.5 4L12 7.5"
        stroke="#F57F20"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5004 13.4994H6.00041L2.53223 10.0312"
        stroke="#F57F20"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function PinIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 12V15"
        stroke="#7E00FD"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.4383 11.394C13.2798 10.6266 12.8275 9.95158 12.178 9.51311C12.1178 9.47153 12.0675 9.41724 12.0306 9.35408C11.9937 9.29092 11.9711 9.22043 11.9644 9.14759L11.2946 2.45024C11.2822 2.32686 11.2245 2.21247 11.1325 2.12927C11.0406 2.04607 10.921 2 10.797 2H5.202C5.07801 2 4.95844 2.04607 4.86651 2.12927C4.77457 2.21247 4.71683 2.32686 4.70449 2.45024L4.0346 9.14759C4.02793 9.22043 4.00535 9.29092 3.96845 9.35408C3.93156 9.41724 3.88124 9.47153 3.82107 9.51311C3.17159 9.95158 2.71928 10.6266 2.56075 11.394C2.54526 11.467 2.54622 11.5425 2.56358 11.615C2.58094 11.6876 2.61425 11.7553 2.66109 11.8134C2.70793 11.8714 2.76713 11.9183 2.83436 11.9506C2.9016 11.9828 2.97519 11.9997 3.04977 12H12.9493C13.0239 11.9997 13.0974 11.9828 13.1647 11.9506C13.2319 11.9183 13.2911 11.8714 13.3379 11.8134C13.3848 11.7553 13.4181 11.6876 13.4355 11.615C13.4528 11.5425 13.4538 11.467 13.4383 11.394Z"
        stroke="#7E00FD"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function LinkIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.73598 5.85858C4.85162 6.28181 5.10318 6.65529 5.45192 6.92151C5.80066 7.18773 6.22724 7.33193 6.66598 7.33192H9.33265C10.118 7.33197 10.8781 7.60927 11.479 8.11492C12.0799 8.62058 12.483 9.32213 12.6173 10.0959C13.0698 10.2435 13.4548 10.5476 13.7032 10.9536C13.9517 11.3595 14.0473 11.8407 13.9728 12.3108C13.8984 12.7809 13.6588 13.2091 13.2971 13.5184C12.9354 13.8277 12.4753 13.998 11.9993 13.9986C11.5337 13.9989 11.0825 13.8368 10.7236 13.5402C10.3647 13.2435 10.1205 12.8309 10.0332 12.3735C9.94593 11.9161 10.021 11.4426 10.2454 11.0346C10.4698 10.6266 10.8296 10.3097 11.2626 10.1386C11.147 9.71536 10.8954 9.34188 10.5467 9.07566C10.198 8.80944 9.77139 8.66523 9.33265 8.66525H6.66598C5.94457 8.66631 5.24247 8.43228 4.66598 7.99858V10.1119C5.11097 10.2692 5.48604 10.5787 5.72489 10.9858C5.96373 11.3929 6.05097 11.8713 5.97119 12.3364C5.8914 12.8016 5.64973 13.2236 5.28889 13.5278C4.92805 13.8321 4.47128 13.9989 3.99931 13.9989C3.52734 13.9989 3.07057 13.8321 2.70973 13.5278C2.34889 13.2236 2.10722 12.8016 2.02744 12.3364C1.94766 11.8713 2.0349 11.3929 2.27374 10.9858C2.51258 10.5787 2.88765 10.2692 3.33265 10.1119V5.88525C2.89063 5.72919 2.51745 5.42288 2.27821 5.01976C2.03898 4.61665 1.94889 4.14233 2.02367 3.67957C2.09844 3.21682 2.33333 2.79501 2.68735 2.48776C3.04137 2.1805 3.49203 2.00731 3.96071 1.99841C4.42938 1.9895 4.8863 2.14545 5.25173 2.43903C5.61717 2.73261 5.86791 3.14519 5.96022 3.60477C6.05252 4.06435 5.98051 4.54175 5.75677 4.95366C5.53302 5.36557 5.17175 5.68584 4.73598 5.85858ZM3.99931 4.66525C4.17612 4.66525 4.34569 4.59501 4.47072 4.46999C4.59574 4.34496 4.66598 4.17539 4.66598 3.99858C4.66598 3.82177 4.59574 3.6522 4.47072 3.52718C4.34569 3.40215 4.17612 3.33192 3.99931 3.33192C3.8225 3.33192 3.65293 3.40215 3.52791 3.52718C3.40288 3.6522 3.33265 3.82177 3.33265 3.99858C3.33265 4.17539 3.40288 4.34496 3.52791 4.46999C3.65293 4.59501 3.8225 4.66525 3.99931 4.66525ZM3.99931 12.6652C4.17612 12.6652 4.34569 12.595 4.47072 12.47C4.59574 12.345 4.66598 12.1754 4.66598 11.9986C4.66598 11.8218 4.59574 11.6522 4.47072 11.5272C4.34569 11.4022 4.17612 11.3319 3.99931 11.3319C3.8225 11.3319 3.65293 11.4022 3.52791 11.5272C3.40288 11.6522 3.33265 11.8218 3.33265 11.9986C3.33265 12.1754 3.40288 12.345 3.52791 12.47C3.65293 12.595 3.8225 12.6652 3.99931 12.6652ZM11.9993 12.6652C12.1761 12.6652 12.3457 12.595 12.4707 12.47C12.5957 12.345 12.666 12.1754 12.666 11.9986C12.666 11.8218 12.5957 11.6522 12.4707 11.5272C12.3457 11.4022 12.1761 11.3319 11.9993 11.3319C11.8225 11.3319 11.6529 11.4022 11.5279 11.5272C11.4029 11.6522 11.3326 11.8218 11.3326 11.9986C11.3326 12.1754 11.4029 12.345 11.5279 12.47C11.6529 12.595 11.8225 12.6652 11.9993 12.6652Z"
        fill="#292E73"
        fillOpacity="0.42"
      />
    </svg>
  );
}

export function BtnPlusIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 3.33203V12.6654"
        stroke="#080F6C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.33398 8H12.6673"
        stroke="#080F6C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
